import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ccf781b")

_pushScopeId("data-v-6ccf781b")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "main__section" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectedHospital = _resolveComponent("SelectedHospital")
  const _component_SecondOpinionRequest = _resolveComponent("SecondOpinionRequest", true)

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock("main", _hoisted_1, [
        _createVNode("section", _hoisted_2, [
          (_ctx.state.selectHospital !== 0 && !_ctx.state.selectHospital)
            ? (_openBlock(), _createBlock(_component_SelectedHospital, {
                key: 0,
                onSelected: _cache[1] || (_cache[1] = (key)=>_ctx.state.selectHospital = key )
              }))
            : (_openBlock(), _createBlock(_component_SecondOpinionRequest, {
                key: 1,
                hospitalKey: _ctx.state.selectHospital.valueOf()
              }, null, 8, ["hospitalKey"]))
        ])
      ]))
    : _createCommentVNode("", true)
})